import { useState, useEffect } from 'react';

const CountdownTimer = ({ targetDate }) => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  useEffect(() => {
    const calculateTimeLeft = () => {
      const difference = new Date(targetDate) - new Date();
      
      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((difference / 1000 / 60) % 60),
          seconds: Math.floor((difference / 1000) % 60),
        });
      } else {
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      }
    };

    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(timer);
  }, [targetDate]);

  const formatNumber = (num) => String(num).padStart(2, '0');

  return (
    <div className="countdown-container" data-testid="countdown-timer">
      <div className="countdown-item">
        <span className="countdown-number" data-testid="countdown-days">
          {formatNumber(timeLeft.days)}
        </span>
        <span className="countdown-label">Days</span>
      </div>
      
      <span className="countdown-separator">:</span>
      
      <div className="countdown-item">
        <span className="countdown-number" data-testid="countdown-hours">
          {formatNumber(timeLeft.hours)}
        </span>
        <span className="countdown-label">Hours</span>
      </div>
      
      <span className="countdown-separator">:</span>
      
      <div className="countdown-item">
        <span className="countdown-number" data-testid="countdown-minutes">
          {formatNumber(timeLeft.minutes)}
        </span>
        <span className="countdown-label">Minutes</span>
      </div>
      
      <span className="countdown-separator">:</span>
      
      <div className="countdown-item">
        <span className="countdown-number" data-testid="countdown-seconds">
          {formatNumber(timeLeft.seconds)}
        </span>
        <span className="countdown-label">Seconds</span>
      </div>
    </div>
  );
};

export default CountdownTimer;
